(function(){
	'use strict';
	angular.module('app.common')
	.controller('regionalSmsCtrl',[
		'$scope',
		'regionStorageFactory', 
		'campaignPhoneOverride',
		function(
			$scope, 
			regionStorageFactory,
			campaignPhoneOverride){

				var campaignPhone = campaignPhoneOverride.getOverridePhoneForCurrentRegion();
				$scope.sms = campaignPhone || regionStorageFactory.getRegionPhone() || '855-342-2281';
				$scope.tel = ($scope.sms || '').replace(/\D/g, '');
			}]);
}());